import { axiosGet, axiosPost,axiosPut, axiosDelete } from "../options/header"

export default {
    addNewSifra(sifra_val) {
        try {
            return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/payment/sifra", {
                params: {
                    sifra_val
                },
                credentials: true,
            });
        } catch (err) {
            console.log(err);
        }
    },
    editSifra(sifra_val) {
        try {
            return axiosPut(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/payment/sifra/" + sifra_val.uid, {
                params: {
                    sifra_val
                },
                credentials: true,
            });
        } catch (err) {
            console.log(err);
        }
    },
    deleteSifra(uid) {
        try {
            return axiosDelete(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/payment/sifra/" + uid, {
                params: {
                },
                credentials: true,
            });
        } catch (err) {
            console.log(err);
        }
    },
    getAllSifra() {
        try {
            return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/payment/sifra", {
                credentials: true,
            });
        } catch (err) {
            console.log(err);
        }
    },


}